import React, { Component } from 'react';

class ScrollingText extends Component {
  render() {
    const {
      message = 'Contact to 7870421111 for Registration or BMMS ID and Password.',
      speed = 15,
      textColor = 'white',
      backgroundColor,
      fontSize = '16px',
      fontWeight = '',
      height = '40px',
      emoji,
      emojiPosition = 'start',
      emojiColor,
      emojiAnimation = 'wave', // wave | bounce | pulse | scale | colorChange
    } = this.props;

    // Define emoji animation styles
    const emojiAnimationKeyframes = {
      wave: `
        @keyframes emojiAnim {
          0% { transform: rotate(0deg); }
          20% { transform: rotate(-20deg); }
          40% { transform: rotate(20deg); }
          60% { transform: rotate(-10deg); }
          80% { transform: rotate(10deg); }
          100% { transform: rotate(0deg); }
        }
      `,
      bounce: `
        @keyframes emojiAnim {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
      `,
      pulse: `
        @keyframes emojiAnim {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
      `,
      scale: `
        @keyframes emojiAnim {
          0% { transform: scale(1); }
          50% { transform: scale(1.4); }
          100% { transform: scale(1); }
        }
      `,
      colorChange: `
        @keyframes emojiAnim {
          0% { color: red; }
          25% { color: orange; }
          50% { color: yellow; }
          75% { color: green; }
          100% { color: blue; }
        }
      `,
    };

    const emojiStyle = {
      display: 'inline-block',
      marginRight: emojiPosition === 'start' ? '8px' : '',
      marginLeft: emojiPosition === 'end' ? '8px' : '',
      color: emojiColor || 'inherit',
      animation: `emojiAnim 1.5s ease-in-out infinite`,
    };

    const scrollAnim = `
      @keyframes scrollText {
        0% { transform: translateX(100%); }
        100% { transform: translateX(-100%); }
      }
    `;

    return (
      <div
        style={{
          width: '100%',
          overflow: 'hidden',
          backgroundColor: backgroundColor || 'transparent',
          height,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'inline-block',
            whiteSpace: 'nowrap',
            animation: `scrollText ${speed}s linear infinite`,
            fontSize,
            fontWeight,
            color: textColor,
            minWidth: '100%', // make sure animation covers full width
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.animationPlayState = 'paused';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.animationPlayState = 'running';
          }}
        >
          {emojiPosition === 'start' && emoji && (
            <span style={emojiStyle}>{emoji}</span>
          )}
          {message}
          {emojiPosition === 'end' && emoji && (
            <span style={emojiStyle}>{emoji}</span>
          )}
        </div>

        <style>
          {scrollAnim}
          {emojiAnimationKeyframes[emojiAnimation] || ''}
        </style>
      </div>
    );
  }
}

export default ScrollingText;
